/**
 * @copyright Copyright 2025 Epic Systems Corporation
 * @file Shared Organization Management filters
 * @module Epic.AppOrchard.OrganizationManagement.Data
 */

import { IColumnDefinition } from "ao/types";

//#region Base column definitions
export const IdColumn: IColumnDefinition = {
	key: "id",
	name: "ID",
	tooltip: "Organization ID",
	defaultShow: true,
	isSortable: true,
	minWidth: 75,
	maxWidth: 75,
};

export const NameColumn: IColumnDefinition = {
	key: "name",
	name: "Legal Name",
	tooltip: "Legal Name",
	defaultShow: true,
	isSortable: true,
	width: 300,
	minWidth: 200,
	maxWidth: 400,
};

export const OrganizationSourceColumn: IColumnDefinition = {
	key: "organizationSource",
	name: "Organization Source",
	tooltip: "Organization Source",
	defaultShow: false,
	isSortable: true,
	minWidth: 130,
	maxWidth: 300,
};

export const OrganizationStatusColumn: IColumnDefinition = {
	key: "organizationStatus",
	name: "Organization Status",
	tooltip: "Organization Status",
	defaultShow: true,
	isSortable: true,
	minWidth: 130,
	maxWidth: 300,
};

export const USCDIOrganizationStatusColumn: IColumnDefinition = {
	key: "uscdiOrganizationStatus",
	name: "FHIR Organization Status",
	tooltip: "Epic on FHIR Organization Status",
	defaultShow: true,
	isSortable: true,
	minWidth: 130,
	maxWidth: 300,
};

export const SlgIdColumn: IColumnDefinition = {
	key: "epicCommunityMember_Id",
	name: "SLG ID",
	tooltip: "EpicCommunityMember_Id",
	defaultShow: false,
	isSortable: true,
	minWidth: 50,
	maxWidth: 150,
};

export const LinksColumn: IColumnDefinition = {
	key: "links",
	name: "Links",
	tooltip: "Links",
	defaultShow: true,
	isSortable: false,
	hideInPicker: true,
	minWidth: 200,
	maxWidth: 250,
};
//#endregion
